<template>
  <a-form
    class="mod-form"
    layout="horizontal"
    labelAlign="left"
    :label-col="labelCol"
    :wrapper-col="wrapperCol"
    :colon="false"
    @submit="onSubmit"
  >
    <div style="margin-bottom: 20px; line-height: 24px; color: #000;">为了您的账户安全，请您用会员档案中的联系方式接受验证码，验证成功 进行下一步操作</div>
    <a-form-item label="验证方式">
      <user-verify-type @error="onVerifyTypeError" @change="onVerifyTypeChange"></user-verify-type>
    </a-form-item>
    <a-form-item label="验证码">
      <user-slider-captcha ref="verify" size="large" @change="onCaptchVerify">
      </user-slider-captcha>
    </a-form-item>
    <a-form-item label="手机验证码" v-if="type === 'mobile'">
      <user-verification-code placeholder="请输入手机动态码" size="large" actionText="获取手机动态码" :smsType="smsType === 'mobile' ? 1 : 2" :value="value" :token="token" @change="onVerificationCodeChange">
      </user-verification-code>
    </a-form-item>
    <a-form-item label="邮箱验证码" v-else>
      <user-verification-code placeholder="请输入邮箱动态码" size="large" actionText="获取邮箱动态码" type="email" :smsType="smsType === 'mobile' ? 1 : 2" :value="value" :token="token" @change="onVerificationCodeChange">
      </user-verification-code>
    </a-form-item>
    <a-form-item :wrapper-col="wrapperColOffset">
      <a-button style="margin: 0; width: 100%" type="primary" size="large" :loading="loading" html-type="submit">提交</a-button>
    </a-form-item>
  </a-form>
</template>

<script>
import { verifyCode } from '@/api/verify'
import { isMobile } from '@/utils/util'

export default {
  data () {
    return {
      labelCol: {
        span: 5
      },
      wrapperCol: {
        span: 19
      },
      wrapperColOffset: {
        span: 19, offset: 5
      },
      loading: false,
      token: '',
      code: '',
      value: '',
      type: ''
    }
  },
  props: {
    smsType: String
  },
  methods: {
    async onSubmit (e) {
      e.preventDefault()

      try {
        const { token, code, type, value } = this

        if (!code) {
          this.$error({
            content: `请输入${type === 'mobile' ? '手机' : '邮箱'}动态码！`,
            centered: true
          })
          return
        }

        if (!token) {
          this.$error({
            content: '请拖动滑块完成验证！',
            centered: true
          })
          return
        }

        this.loading = true

        const data = await verifyCode({
          valueInfo: value,
          verifyCode: code,
          verifyType: type === 'mobile' ? 0 : 1
        })

        this.$emit('next', data.token)
      } catch (err) {
        this.$refs.verify.refresh()
        this.$error({
          content: err.message,
          centered: true
        })

        this.loading = false
      }
    },
    onCaptchVerify (value) {
      this.token = value
    },
    onVerificationCodeChange (value) {
      this.code = value
    },
    onVerifyTypeChange (type, value) {
      this.type = type
      this.value = value
    },
    onVerifyTypeError () {
      this.$error({
        content: '对不起，您还未绑定过手机/邮箱，请先完成绑定！',
        centered: true,
        onOk: () => {
          if (isMobile()) {
            window.__MICRO_ROOT__?.eventBus?.emit('BindingSetting::Success', null)
          } else {
            this.$router.replace('/account')
          }
        }
      })
    }
  }
}
</script>
